import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { selectLeagueWithPaymentCheck } from '../supabase';
import { useUserStore } from '../userStore';

export function useLeagueSelection() {
  const navigate = useNavigate();
  const { user_id, setCurrentLeagueId } = useUserStore();
  const [loading, setLoading] = useState(false);

  const selectLeague = async (leagueId: number) => {
    if (!user_id) {
      toast.error('Utilisateur non connecté');
      return { success: false };
    }

    setLoading(true);
    try {
      const result = await selectLeagueWithPaymentCheck(leagueId, Number(user_id));
      
      if (result.success) {
        // Mettre à jour la ligue sélectionnée
        setCurrentLeagueId(leagueId);
        toast.success('Ligue sélectionnée avec succès');
        return { success: true };
      } else if (result.requiresPayment) {
        // Rediriger vers le paiement
        toast('Paiement requis pour accéder à cette ligue', {
          icon: '💳',
          duration: 4000,
        });
        navigate(`/league-payment/${leagueId}`);
        return { success: false, requiresPayment: true };
      } else {
        // Autre erreur
        toast.error(result.error?.message || 'Erreur lors de la sélection');
        return { success: false };
      }
    } catch (error: any) {
      toast.error('Erreur lors de la sélection de la ligue');
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { selectLeague, loading };
}
